import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import { tokenLogin } from '~/store/actions';
import { useAppSelector } from '~/modules/hooks';
import { selectUser } from '~/selectors';
import { STATUS } from '~/literals';
import AnimatingDots from '~/components/AnimatingDots';
import styled from '@emotion/styled';

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 16px;
`;

const TokenLogin = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const user = useAppSelector(selectUser);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      return;
    }

    // Wait for logout to complete, then initiate token login
    if (user.status === STATUS.IDLE) {
      dispatch(tokenLogin({ token }));
    }
  }, [token, user.isAuthenticated, user.status, dispatch]);

  // Redirect to home if no token
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Redirect to dashboard on successful login
  if (user.isAuthenticated && user.status === STATUS.READY) {
    return <Navigate to="/private/dashboard" replace />;
  }

  return (
    <LoaderContainer>
      <AnimatingDots color="#000" successiveDelay={0.2} />
    </LoaderContainer>
  );
};

export default TokenLogin;
